module.exports = "<div class='document-error'>\r\n    <h2>Sorry</h2>\r\n    <p style=\"width:300px; margin:auto\">{{Model.ErrorMessage}}</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/document-error.html
// module id = 339
// module chunks = 1